import { ModeKey } from "../ai-agent-Interface/ai-agent.interface";

export type SessionStatus =
  | "SUCCESS"
  | "FAILED"
  | "STARTED"
  | "MANUAL_INTERVENTION";

export type AgentStatus =
  | "SUCCESS"
  | "NOT_STARTED"
  | "STARTED"
  | "MANUAL_INTERVENTION"
  | "NOT_INCLUDED"
  | "FAILURE";

export const INTRO_LINE =
  "Select an option so that the agent can clarify the details and provide the best output for your request.";

export const PROJECT_TYPE = "Core";

export const GEN_AI_TYPE: string[] = ["Enable", "Disable"];

export const RENAME_SESSION = "Session Renamed Successfully";

export const DELETE_SESSION = "Session Deleted Successfully";

export const NO_USERTORY_ATTACHED = "No userstory attached to this L4";

export const INLOCAL = "local";

export const HEADER = "Header";

export const PASSED = "PASSED";

export const OBJECT = "object";

export const DETAILS = "DETAILS";

export const FAULTED = "Faulted";

export const TEAM_MEMBERS = "TEAM_MEMBERS";

export const NOT_PROVIDED = "Not provided";

export const EDIT = "EDIT";

export const TESTSTEP ="TESTSTEP";

export const FILE_UPLOAD = "FILE_UPLOAD";

export const DELOITTE_DATA = "Use Deloitte Data";

export const WEB_SEARCH = "Use Web Search";

export const BOT_AUTOGENERATE = "BOT_AUTOGENERATE";

export const SUPPORTED_FILES = "Supported formats: PDF, TXT, DOCX, PNG, JPEG, JPG (Max 10MB)";

export const BLOB_FILE_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

export const FOOTER_TEXTS: Record<number, string> = {
  1: "Please select the start and end of the flow auto-generation. Include the manual review of agent outputs in the appropriate cards where necessary.",
  2: "Please select the levels at the root of which data will be created for further auto-generation.",
  3: "Please apply the parameters on the basis of which test cases will be created for further automatic generation.",
  4: "You can clarify your request before procedding",
};

export const AGENT_EXECUTION_STEPS: { label: string }[] = [
  { label: "Workflow" },
  { label: "Input" },
  { label: "Settings" },
  { label: "Run" },
];

export const ITERATION_DATA = ["Iteration 1", "Iteration 2", "Iteration 3"];

export const AGENT_STATUS = {
  SUCCESS: "SUCCESS",
  NOT_STARTED: "NOT_STARTED",
  STARTED: "STARTED",
  MANUAL_INTERVENTION: "MANUAL_INTERVENTION",
  NOT_INCLUDED: "NOT_INCLUDED",
  FAILURE: "FAILURE",
};

export const GENERATION_FOOTER = {
  GENERATE_TEST_DATA: "You can change Test Data for the Bot if necessary..",
};

export const AUTO_GENERATE_ADDITIONAL_DATA = "AUTO_GENERATE_ADDITIONAL_DATA";
export const NO_L4_EXISTS_MESSAGE = "This L4 does not have any test case.";
export const NO_BOT_EXISTS_MESSAGE =
  "This test does not contain any bot. Please select another test case.";
export const BOT_ASSOCIATION_WARNING =
  "This item is currently associated with a bot named {TRANSACTION_NAME}. Please return to user mode to detach the bot from this test case before proceeding.";
export const TEST_DATA_SUCCESSFULLY_REVIEWED =
  "Test Data Generation successfully reviewed.";
export const TEST_DATA_SUCCESSFULLY_GENERATED =
  "Test Data Successfully Generated";
export const DISABLE_TOOLTIP_TEXT ="Select and fill step details to proceed";  

export const AGENT_TYPE = {
  GENERATE_TEST_CASES: "GenerateTestCases",
  ANALYSE_TEST_CASES: "AnalyzeTestCases",
  GENERATE_TEST_STEPS: "GenerateTestSteps",
  GENERATE_BOT: "GenerateBot",
  GENERATE_TEST_DATA: "GenerateTestData",
  EXECUTE_BOT: "ExecuteBot",
  ANALYZE_TEST_RESULTS: "AnalyzeTestResults",
  CREATE_DEFECT: "CreateDefect",
};

export const SUMMARY_HEADINGS = [
  "Summary:",
  "Steps_details:",
  "Business Objective:",
  "Transaction Details:",
  "Steps Performed:",
  "Outcome:",
  "Probable Root Cause (if failed):",
];

export const REQUEST_KEY  = {
  TAXONOMY_DETAILS : "TAXONOMY_DETAILS",
  APP_VERSION_DETAILS : "APP_VERSION_DETAILS",
  APP_VERSION : "APP_VERSION",
  LAST_SELECTED_DETAILS : "LAST_SELECTED_DETAILS",
  ITEM_TYPE : "AGENTIC_GENERATE_TEST_STEPS",
  BOT : "bot",
  ADD_BOT : "add_bot",
  ADD_BOT_TEMPLATE : "add_bot_template",
}

export const SNACKBAR_MSG = {
  FAILED_ALM_EXPORT: "Failed to Export to ALM",
  FAILED_EXCEL_EXPORT: "Failed to Export to Excel",
};

export const TEST_CASES_GENERATED_SUCCESSFULLY =
  "Test Cases have been generated successfully";
export const TEST_CASES_FOOTER_INFO =
  "Please select Test Cases. Generation will continue based on your selection.";
export const TEST_STEPS_FOOTER_INFO =
  "You can edit, delete, or create new Test Steps if necessary.";  
export const TEST_CASES_REVIEWD_SUCCESSFULLY =
  "Test Cases Generation successfully Reviewed";
export const TEST_STEPS_GENERATION_COMPLETED =
  "Test Steps Generation successfully Completed";
export const TEST_STEPS_GENERATED_SUCCESSFULLY =
  "Test Steps have been generated successfully";
export const BOT_GENERATION_STARTED = "The Bot Generation process has started.";
export const BOT_CONTENT_GENERATED = "Bots content successfully generated.";
export const BOT_GENERATION_COMPLETED =
  "Bot Generation successfully Completed.";
export const BOT_GENERATION_FOOTER_INFO =
  "Please select Bots. Generation will continue based on your selection.";
export const EDIT_EXECUTION_TITLE = "Edit Execution Flow Manually";
export const EDIT_EXECUTION_FLOW =
  "Edit the execution flow by modifying objects and their sequence. Changes will be applied to the bot generation";
export const BOT_EXECUTION_GENERATED =
  "Bot Execution Data successfully generated";
export const allowedAgents = [0, 1, 2, 3, 4, 5, 6, 7];
export const shouldStopPollingStatus = [
  "SUCCESS",
  "TERMINATED",
  "FAILED",
  "FAILURE",
  "RETRY",
];
export const UPLOAD_SUCCESS = "File uploaded successfully!";
export const UPLOAD_FAILED = "File upload failed. Please try again"; 
export const noManualReviewAgents: Record<number, string> = {
  5: "ExecuteBot",
  6: "AnalyzeTestResults",
};
export const fileType = "text/plain;charset=utf-8";
export const spreadSheetFileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
export const screenShotFileType = "application/zip";

export const REASSIGN_BOT = "REASSIGN_BOT";
export const AGENT_POPUP = {
  CLOSE: "close",
  REGENERATE: "regenerate",
  SAME: "same",
};

export const TEST_RESULT_ANALYZE_STARTED =
  "Analyze Test Results process has started.";
export const TEST_RESULT_ANALYZE_COMPLETED =
  "Test Results Analysis successfully Completed.";
export const TEST_CASES_ANALYZE_COMPLETED =
  "Test Cases Analysis successfully completed.";
export const ANALYZE_TEST_CASES_FOOTER_INFO =
  "Please select Test Cases. Generation will continue based on your selection.";
export const ANALYSE_TEST_CASES_STARTED =
  "Test Cases Analysis Process has started.";
export const ANALYSE_TEST_CASE_MSG =
  "The system will analyze the Test Cases and identify duplicates and newly generated ones.";
export const REVIEW = "Review";
export const REVIEWED = "✔ Reviewed";
export const FILTER_ALM_DEFECT_STATUS = "ALM_Defect_Status";
export const FILTER_ALM_DEFECT_SEVERITY = "ALM_Defect_Severity";
export const FILTER_ALM_DEFECT_PRIORITY = "ALM_Defect_Priority";
export const FILTER_ALM_DEFECT_TYPE = "ALM_Defect_Type";
export const FILTER_ALM_DEFECT_CAUSE = "ALM_Defect_Cause";
export const DEFECT_CREATION_MSG = "The Defect Creation process has started."
export const CREATE_DEFECT_FOOTER_TEXT =
  "You can edit Defect Data before exporting if necessary.";
export const SESSION_COMPLETION_MSG =
  "Great job! Autogeneration completed successfully.";
export const ALL_STEPS_COMPLETED_MSG = `All steps of the workflow autogeneration were successfully completed. The
history of all completed processes is saved in this session, download
materials that were generated in previous steps are always available. If
necessary, you can run session regeneration, then a new session with
identical presets will be created.`;
export const NO_FAILED_BOT_MSG = `After the 'Analyze Test Results' process, bots with a 'FAILED' test
result were identified. The next step, 'Create Defect' for failed bots,
has been activated.`

export const BOT_NOT_AVAILABLE = "No Bot Available. To continue Autogeneration, create a test case Bot manually.";

export const GENERATE_BOT_FAILED = "No Bots available. The system is not able to suggest suitable Bots for the Test Cases. Please try editing the test case name or selecting different test cases through Run New Session.";

export const TEST_STEPS_FAILED = "All the Test Cases generated are duplicates. These test cases already exist under this L4. Try generation for different L4s through Run New Session.";

export const COMMON_FAILED = " has failed, Please run new session.";

export const NO_TEST_STEPS = "No test steps available for this test case";

export const DEFECT_ALREADY_CREATED = "Defect Already Created.";

export const CREATE_DEFECT_REVIEW_REQUIRED = "Manual review is always required for Create Defect";
export const NO_BOTS_FOUND = "No bots found";
export const NEW_BOT = "New Bot";
export const ERROR_FETCHING_BOT ="Error fetching bot dictionary";
export const SESSION_NAME_MAX_LEN = 32;
export const CHANGE_MODE_INFO = "Select the interaction mode that best suits your workflow — engage with the agent via chat or proceed through a structured step-by-step flow.";
export const AGENTIC_MODES: ReadonlyArray<{ key: ModeKey; label: string }> = [
  { key: 'conversational', label: 'Conversational Mode' },
  { key: 'agentic', label: 'Agentic Flow Mode' },
] as const;
export const CHATBOT_FAILED_MSG = "Sorry—something went wrong. Please try again.";
export const CHATBOT_MSG_ANALYZING_MSG = "Analyzing is underway...";
export const AGENTIC = "agentic";
export const CONVERSATIONAL = "conversational";